<template>
  <div class="products">
    <div v-for="(name, index) of productNames" :key="name + index" class="products__product">
      <app-product :product-name="name" image-lazy />
    </div>
  </div>
</template>

<script>
import AppProduct from '@/components/common/AppProduct.vue';

export default {
  name: 'YourRoutineProductsList',
  components: { AppProduct },
  props: {
    productNames: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.products {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 13px;

  &__product {
    min-width: 138px;
    width: 43vw;
    max-width: 425px;
    margin-bottom: 32px;
  }
}

@media (min-width: 360px) {
  .products {
    grid-column-gap: 19px;
  }
}

@media (min-width: 600px) {
  .products {
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 32px;

    &__product {
      min-width: 138px;
      width: 100%;
      max-width: 425px;
    }
  }
}
</style>
